import Vue from "vue";
import Router from "vue-router";

import store from "@/store/index";

//import Home from "./pages/Home.vue";
//import About from "./pages/About.vue";
//import Octopi from "./pages/Octopi.vue";
//import NotFoundPage from "./pages/NotFoundPage.vue";
//import ModuleNotReady from "./pages/ModuleNotReady.vue";

//import Contact from "./views/Contact.vue";

//import Users from "./components/auth/Users.vue";
//import Register from "./components/auth/Register.vue";
//import Login from "./components/auth/Login.vue";
//import ForgotPassword from "./components/auth/ForgotPassword.vue";
//import Password from "./components/auth/Password.vue";

//import guest from "./components/portal/anonymous/Main";

//import Portal from "./views/Portal.vue";
//const Portal = () => import("./views/Portal.vue");
//import Dashboard from "./components/portal/Dashboard.vue";
//import Account from "./components/portal/ConsigneeAccount.vue";
//import Containers from "./components/portal/Containers.vue";
//import Billofladings from "./pages/ModuleNotReady.vue";
//import UnitsAtTerminal from "./components/portal/global/UnitsAtTerminal.vue";
//import UnitsAtConsignee from "./components/portal/global/UnitsAtConsignee.vue";
//import Outstandings from "./components/portal/global/Outstandings.vue";
//import DocumentList from "./components/portal/DocumentList.vue";
//import TransactionList from "./components/portal/TransactionList.vue";
//import PContact from "./components/portal/global/Contact.vue";

//import Rates from "./components/portal/global/Rates.vue";

//import Overview from "./pages/Overview.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    /*
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
    },
    {
      path: "/octopi",
      name: "octopi",
      component: () => import("@/pages/Octopi.vue"),
    },
    */
    {
      path: "/spy-octopi-movements.html",
      name: "octopi",
      //component: () => import("@/pages/Octopi.vue"),
    },
    {
      path: "/users",
      name: "users",
      component: () => import("@/components/auth/Users.vue"), //Users,
      children: [
        {
          path: "login",
          name: "login",
          component: () => import("@/components/auth/Login.vue"), //Login,
        },
        {
          path: "request/:id",
          name: "password",
          component: () => import("@/components/auth/Password.vue"), //Password,
        },
        {
          path: "password/:email",
          name: "password",
          component: () => import("@/components/auth/Password.vue"), //Password,
        },
        /*{
          path: "resetpassword",
          name: "resetpassword",
          component: ResetPassword,
        },*/
        {
          path: "forgotpassword",
          name: "forgotpassword",
          component: () => import("@/components/auth/ForgotPassword.vue"), //ForgotPassword,
        },
        /*
        {
          path: "register",
          name: "register",
          component: Register,
        },
        {
          path: "profile",
          name: "profile",
          component: ModuleNotReady,
          meta: {
            requiresAuth: true,
          },
        },
        */
      ],
    },
    {
      path: "/portal",
      name: "portal",
      component: () => import("@/components/portal/Portal.vue"), //Portal,
      children: [
        /*
        {
          path: "guest",
          name: "guest",
          component: guest,
        },
        */
        {
          path: "dashboard",
          name: "dashboard",
          component: () => import("@/components/portal/Dashboard.vue"),
          meta: {
            requiresAuth: true,
          },
        },
        /*{
          path: "account",
          name: "account",
          component: Account,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "billofladings",
          name: "billofladings",
          component: Billofladings,
          meta: {
            requiresAuth: true,
          },
        },*/
        {
          path: "collections",
          name: "collections",
          component: () => import("@/components/portal/global/Collections.vue"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "containers",
          name: "containers",
          component: () => import("@/components/portal/global/Containers.vue"), //Containers,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "unitsatterminal",
          name: "unitsatterminal",
          component: () =>
            import("@/components/portal/global/UnitsAtTerminal.vue"), //UnitsAtTerminal,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "unitsatconsignee",
          name: "unitsatconsignee",
          component: () =>
            import("@/components/portal/global/UnitsAtConsignee.vue"), //UnitsAtConsignee,
          meta: {
            requiresAuth: true,
          },
        },
        /*{
          path: "documents",
          name: "documents",
          component: DocumentList,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "transactions",
          name: "transactions",
          component: TransactionList,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "gatelogs",
          name: "gatelogs",
          component: NotFoundPage,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "rates",
          name: "rates",
          component: Rates,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "users",
          name: "users",
          component: ModuleNotReady,
          meta: {
            requiresAuth: true,
          },
        },*/
        {
          path: "outstandings",
          name: "outstandings",
          component: () =>
            import("@/components/portal/global/Outstandings.vue"), //Outstandings,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "contact",
          name: "contact",
          component: () => import("@/components/portal/global/Contact.vue"), //PContact,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "*",
      name: "NotFoundPage",
      //component: NotFoundPage,
      redirect: "/portal",
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.isLoggedIn) {
      //if (store.state.authLevel == 7 ) {
      //  next("/users/containers");
      //  return;
      //}
      next();
      return;
    } else {
      store
        .dispatch("autoSignIn")
        .then(() => {
          store.dispatch("load_profile", store.state.current_profile)
          //store.dispatch("load_dashboard_data");
          if (to.path == "/portal") {
            next("/portal/dashboard");
            return;
          }
          next();
          return;
        })
        .catch(() => {
          next("/users/login");
          return;
        });
    }
  } else {
    if (store.state.isLoggedIn) {
      //if (store.state.authLevel == 7 ) {
      //  next("/users/containers");
      //  return;
      //}
      if (to.path == "/portal") {
        next("/portal/dashboard");
        return;
      }
    } else if (
      to.path == "/portal" ||
      to.matched.some((record) => record.meta.requiresAuth)
    ) {
      store
        .dispatch("autoSignIn")
        .then(() => {
          store.dispatch("load_profile", store.state.current_profile)
          //store.dispatch("load_dashboard_data");
          if (to.path == "/portal") {
            next("/portal/dashboard");
            return;
          }
          next();
          return;
        })
        .catch(() => {
          next("/users/login");
        });

      if (to.path == "/portal") {
        next("/users/login");
        return;
      }
    }
    next();
  }
});

export default router;
